// extracted by mini-css-extract-plugin
export default {"pointer":"user-avatar_pointer__YSiWC"};